/**
 * MemberActivityTab 相关 API 接口
 */
import $x from '@/utils/$x';

/** 查询会员周参与达标概览 */
export async function getWeeklyParticipateStatus(params) {
  return $x.post('/user/info/getWeeklyParticipateStatus', params);
}

/** 查询用户在店记录 */
export async function queryUserInStoreRecords(params) {
  return $x.post('/user/info/queryUserInStoreRecords', params);
}

/** 查询用户在店记录详情 */
export async function queryUserInStoreRecordDetail(params) {
  return $x.post('/user/info/queryUserInStoreRecordDetail', params);
}

/** 入镜指导课列表 */
export async function queryXplanCourseList(params) {
  return $x.post('/user/info/queryXplanCourseList', params);
}

/** 入镜指导课详情 */
export async function queryXplanCourseDetail(params) {
  return $x.post('/user/info/queryXplanCourseDetail', params);
}

/** 查询联名卡订单记录 */
export async function queryVitalityGoOrderList(params) {
  return $x.post('/user/info/queryVitalityGoOrderList', params);
}
/** 查询用户基本信息 */
export async function queryUserBaseInfo(params) {
  return $x.post('/user/info/queryUserBaseInfo', params);
}

/** 查询活力Go用户训练统计数据（热力图） */
export async function queryVitalityGeneralStats(params) {
  return $x.post('/user/vitality/general/stats', params);
}

/** 查询活力Go用户每日活动时间线详情 */
export async function queryVitalityDailyTimeline(params) {
  return $x.post('/user/vitality/timeline/daily', params);
}

/**
 * 查询订单统计信息
 * @param {*} params
 * @returns
 */
export async function queryVitalityGoOrderStatisticList(params) {
  return $x.post('/user/info/queryVitalityGoOrderStatisticList', params);
}

/** 查询活力Go用户奖励记录（连续达标里程碑） */
export async function queryVitalityRewardRecords(params) {
  return $x.post('/user/vitality/reward/records', params);
}

/** 查询活力Go用户达标情况统计 */
export async function queryVitalityTaskStats(params) {
  return $x.post('/user/vitality/task/stats', params);
}
